module.exports = __webpack_public_path__ + "static/img/ask5-tit.3d14902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask5-tit.png
// module id = 46PD
// module chunks = 0